import TagManager from 'react-gtm-module';
import { isEmpty } from 'lib';
import { store } from 'store';
import { getEnv } from './getEnv';

export function googleTagManager() {
  const { currentUser, hijackerUser } = store.getState().accountReducer;
  const currentActiveUser = !isEmpty(hijackerUser) ? hijackerUser : currentUser;

  const init = () => {
    if (getEnv('REACT_APP_GTM_ID')) {
      const tagManagerArgs = {
        gtmId: getEnv('REACT_APP_GTM_ID'),
        dataLayer: {
          userId: currentActiveUser?.user?.id,
          userProject: `${currentActiveUser?.user?.name} ${currentActiveUser?.user?.last_name}`,
        },
      };
      TagManager.initialize(tagManagerArgs);
    }
  };

  return {
    init,
  };
}
